import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { DepartMentService } from 'src/app/private/services/department.service';
import { SharedModule } from 'src/app/private/shared/shared.module';

@Component({
  selector: 'app-create-department',
  standalone: true,
  imports: [SharedModule],
  templateUrl: './create-department.component.html',
  styleUrl: './create-department.component.scss',
})
export class CreateDepartmentComponent {
  @Input() clientId: string = '';
  @Input() departmentDataToEdit: any = null;
  @Input() centers: any[] = [];
  @Input() type = 'Create';
  @Output() close = new EventEmitter<void>();
  @Output() reload = new EventEmitter<void>();

  departmentForm: FormGroup;
  submitted = false;
  isLoading = false;

  constructor(
    private fb: FormBuilder,
    private deptService: DepartMentService,
    private messageService: MessageService
  ) {
    this.departmentForm = this.fb.group({
      dept_name: ['', Validators.required],
      center_id: ['', Validators.required],
      isPublic: [false],
      client_id: [''] // to be set on init
    });
  }

  ngOnInit() {
    if (this.type === 'Update' && this.departmentDataToEdit) {
      this.departmentForm.patchValue(this.departmentDataToEdit);
      // covner center_id to string if it's a number
      if (typeof this.departmentDataToEdit.center_id === 'number') {
        this.departmentForm.patchValue({ center_id: this.departmentDataToEdit.center_id.toString() });
      }
    }

    this.departmentForm.patchValue({ client_id: this.clientId });
  }

  handleCloseDialog() {
    this.close.emit();
  }

  submitForm() {
    this.submitted = true;

    if (this.departmentForm.invalid) {
      this.departmentForm.markAllAsTouched();
      return;
    }

    const payload = this.departmentForm.value;
    payload.client_id = this.clientId; // Ensure client_id is set
    this.isLoading = true;

    if (this.type === 'Update') {
      payload.dept_id = this.departmentDataToEdit.dept_id;
      this.deptService.updateDepartment(payload).subscribe({
        next: () => {
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Department updated successfully!' });
          this.reload.emit();
          this.handleCloseDialog();
        },
        error: (error) => {
          this.isLoading = false;

          this.messageService.add({ severity: 'error', summary: 'Error', detail: error || 'Failed to update department!' });
        },
        complete: () => {
          this.isLoading = false;
        }
      });
    } else {
      this.deptService.createDepartment(payload).subscribe({
        next: () => {
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Department created successfully!' });
          this.reload.emit();
          this.handleCloseDialog();
        },
        error: (error) => {
          this.isLoading = false;

          this.messageService.add({ severity: 'error', summary: 'Error', detail: error || 'Failed to create department!' });
        },
        complete: () => {
          this.isLoading = false;
        }
      });
    }
  }
}
